import { useContext, useRef } from "react";
import {
  FirmaFiltersContext,
  FirmaFiltersEventContext,
} from "../../../../../context/FiltersContext";
import {
  QueryFilter,
  FirmaFilterKeys,
  FirmaVirksomhedsTypeSetting,
} from "../../../../../interfaces/filters";
import {
  FirmaDtoFilterInput,
  Firmatype,
} from "../../../../../interfaces/schema";
import { f } from "../../../../../util/f";
import { AccordionFilterItem } from "../../../../accordion/Accordion";
import InputCheckbox from "../../../../formcontrols/InputCheckbox";
// import DateFilter from "../../../../filter/date/DateFilter";
// import { defaultDateEvent } from "../../../../filter/date/dateFilterHelpers";
// import { DateFilterEvent } from "../../../../filter/date/types";

// helper
const filterKey: QueryFilter<FirmaFilterKeys>["filterKey"] = "selskabstype";

export default function FirmaFirmatypeFilter() {
  // query filter context
  const filters = useContext(FirmaFiltersContext);
  const updateFilters = useContext(FirmaFiltersEventContext);

  // find the filter settings
  const settings: FirmaVirksomhedsTypeSetting = filters.find(
    (f) => f.filterKey === filterKey,
  )?.settings;

  // state
  // const [latestDateEvent, setLatestDateEvent] =
  //   useState<DateFilterEvent>(defaultDateEvent);

  // refs
  const advokatVirksomhedRef = useRef<HTMLInputElement>(null);
  const virksomhedRef = useRef<HTMLInputElement>(null);
  const andenEnhedRef = useRef<HTMLInputElement>(null);

  // stuff
  // const isDateDisabled =
  //   settings?.advokatvirksomhed || settings?.virksomhed || settings?.andenEnhed
  //     ? false
  //     : true;

  // filter handler
  function updateFilterHandler() {
    // if (!dateFilterEvent) {
    //   dateFilterEvent = latestDateEvent;
    // } else {
    //   setLatestDateEvent(dateFilterEvent);
    // }

    const firmaTypeIds: Firmatype[] = [];

    if (advokatVirksomhedRef.current?.checked) {
      firmaTypeIds.push(Firmatype.Advokatvirksomhed);
    }

    if (virksomhedRef.current?.checked) {
      firmaTypeIds.push(Firmatype.Virksomhed);
    }

    if (andenEnhedRef.current?.checked) {
      firmaTypeIds.push(Firmatype.AndenEnhed);
    }

    if (firmaTypeIds.length > 0) {
      // build query filter
      const queryFilter: QueryFilter<
        FirmaFilterKeys,
        FirmaVirksomhedsTypeSetting
      > = {
        filterKey: filterKey,
        filter: f<FirmaDtoFilterInput>()
          .addFilter(
            "or",
            firmaTypeIds.map((id) => {
              return {
                firmatype: {
                  eq: id,
                },
              };
            }),
          )
          .build(),
        settings: {
          advokatvirksomhed: advokatVirksomhedRef.current?.checked!,
          virksomhed: virksomhedRef.current?.checked!,
          andenEnhed: andenEnhedRef.current?.checked!,
          // dateFilterSettings: dateFilterEvent?.settings,
        },
        parentFilter: "and",
      };

      // NOTE: replaceAll is a workaround for the issue below
      // otherwise we would use IN for enum filters.
      // https://github.com/Septima/Aika-Backend/issues/819
      queryFilter.filter = queryFilter.filter.replaceAll('"', "");

      updateFilters({
        event: "update",
        queryFilter: queryFilter,
      });
    } else {
      updateFilters({
        event: "delete",
        queryFilter: {
          filterKey: filterKey,
        },
      });
    }
  }

  return (
    <AccordionFilterItem
      title="Firmatype"
      value="firmatype"
      isActive={filters.some((f) => f.filterKey === filterKey)}
    >
      <div className="l-flex-grid">
        <InputCheckbox
          label="Advokatvirksomhed"
          id="firma-filter-advokatvirksomhed"
          ref={advokatVirksomhedRef}
          checked={settings?.advokatvirksomhed ?? false}
          onChange={() => {
            updateFilterHandler();
          }}
        />
        <InputCheckbox
          label="Virksomhed"
          id="firma-filter-virksomhed"
          ref={virksomhedRef}
          checked={settings?.virksomhed ?? false}
          onChange={() => {
            updateFilterHandler();
          }}
        />
        <InputCheckbox
          label="Anden Enhed"
          id="firma-filter-anden-enhed"
          ref={andenEnhedRef}
          checked={settings?.andenEnhed ?? false}
          onChange={() => {
            updateFilterHandler();
          }}
        />
      </div>
      {/* <div className="mt-3">
        <DateFilter
          handleChange={(dateFilterEvent) => {
            updateFilterHandler(dateFilterEvent);
          }}
          settings={settings?.dateFilterSettings}
          disabled={isDateDisabled}
        />
      </div> */}
    </AccordionFilterItem>
  );
}
